import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { useRouter } from "next/router"
import SiteWrapper from "../../structure/SiteWrapper/SiteWrapper"
import ImageList from "../ImageList/ImageList"
import MoodboardSelectBar from "../MoodboardSelectBar/MoodboardSelectBar"
import MoodboardSidebar from "../MoodboardSidebar/MoodboardSidebar"
import * as styles from "./MoodboardSearch.module.scss"
import filterObject from "@lib/filterObject"
import fetchLambda from "@data/fetchLambda"
import lambdas from "@data/lambdas"
import { imageOrderOptions } from "@data/static"
import * as actions from "@store/actions"

const { IMAGE_SEARCH } = lambdas[process.env.NEXT_PUBLIC_ENV]

const maxResultsPerLoad = 40
const imigixParams = "?fit=crop&w=600"

const MoodboardSearch = ({
  searchParams,
  staticData,
  moodboardParams,
  selectMoodboard,
  imagesSelectedMoodboard,
  imagesSelectedMoodboardLoad,
  selectMoodboardLoad,
  paramMoodboardLoad,
  empty,
}) => {
  //setup router
  const router = useRouter()

  //filter control
  const [images, updateImages] = useState(null)
  const [searchFilters, updateSearchFilters] = useState(null)
  const [selectFilters, updateSelectFilters] = useState(
    selectMoodboard && Object.keys(selectMoodboard).length
      ? selectMoodboard
      : {
          category: "",
          style: "",
          service: "",
          setting: "",
        }
  )
  const [imageCount, updateImageCount] = useState(null)
  const [isImageSelected, updateIsImageSelected] = useState(
    !!(imagesSelectedMoodboard && Object.keys(imagesSelectedMoodboard).length)
  )
  const [loadMoreActive, updateLoadMoreActive] = useState(true)

  const initialLoad = async () => {
    //setup  init searchFilters
    let initFitlers = {}

    //skip if static data not loaded
    if (!staticData.categoryOptions.length) {
      return
    }

    if (moodboardParams && Object.keys(moodboardParams).length) {
      initFitlers = { ...moodboardParams }
    } else {
      const orderBy = imageOrderOptions[Math.floor(Math.random() * imageOrderOptions.length)]
      initFitlers = {
        first: maxResultsPerLoad,
        skip: 0,
        orderBy: orderBy,
      }
    }

    const urlParams = formatURLSelectParams(searchParams)

    if (urlParams && Object.keys(urlParams).length) {
      //update redux
      selectMoodboardLoad(urlParams)
      updateSelectFilters(urlParams)
      //find tags to update filters
      initFitlers.tags = getTagsFromUrl(urlParams)
    } else if (selectMoodboard && Object.keys(selectMoodboard).length) {
      updateURL(selectMoodboard)
    }

    // updateURL(initFitlers)
    paramMoodboardLoad(initFitlers)
    updateSearchFilters(initFitlers)
    await getImages(initFitlers)
  }

  //init
  useEffect(() => {
    initialLoad()
    window.scrollTo(0, 0)
  }, [])

  const getTagsFromUrl = (query) => {
    const { styleOptions, categoryOptions, settingOptions, serviceTagOptions } = staticData
    let tags = []

    for (const [key, value] of Object.entries(query)) {
      if (!value) {
        continue
      }
      switch (key) {
        case "category":
          tags.push(categoryOptions.find((option) => option.value === value)?.label.toLowerCase())
        case "style":
          tags.push(styleOptions.find((option) => option.value === value)?.label.toLowerCase())
        case "setting":
          tags.push(settingOptions.find((option) => option.value === value)?.label.toLowerCase())
        case "service":
          tags.push(serviceTagOptions.find((option) => option.value === value)?.label.toLowerCase())

        default:
          break
      }
    }

    const output = tags.filter((tag) => tag)

    return output.length ? output : null
  }

  const formatURLSelectParams = (query) => {
    const allowedParams = ["category", "style", "setting", "service"]
    return query ? filterObject(query, allowedParams) : null
  }

  const updateURL = (query) => {
    //construct url format

    let urlParams = []
    for (const [key, value] of Object.entries(query)) {
      if (value) {
        urlParams.push(`${encodeURIComponent(key)}=${typeof value === "object" ? JSON.stringify(value) : value}`)
      }
    }
    urlParams = urlParams.join("&")

    //update url
    window.history.replaceState(null, null, `/moodboard-search/${urlParams ? "?" + urlParams : ""}`)
  }

  const getImages = async (params, append = false) => {
    //reset suppliers object to load spinner
    if (!append) {
      updateImages(null)
      updateLoadMoreActive(true)
      window.scrollTo(0, 0)
    }

    const response = await fetchLambda(IMAGE_SEARCH, {
      params: params,
    })

    if (response) {
      let newImages
      if (response.data.result) {
        newImages = append && images ? [...images, ...response.data.result.allUploads] : response.data.result.allUploads
        const imageCnt = response.data.result._allUploadsMeta.count
        updateImageCount(imageCnt)
        if (imageCnt < maxResultsPerLoad) {
          updateLoadMoreActive(false)
        }
      } else {
        newImages = []
      }

      updateImages(newImages)
    }
  }

  const loadMore = async (page) => {
    if (images.length) {
      const max = maxResultsPerLoad

      await getImages({ ...searchFilters, first: max, skip: max * page }, true)
      updateLoadMoreActive(imageCount - max * page > 0)
    }
  }

  const handleSelectChange = (selected, type) => {
    updateSelectFilters((prevfilters) => {
      let newSelectFilters = { ...prevfilters }
      switch (type.action) {
        case "select-option":
          newSelectFilters[type.name] = selected.value
          if (type.name === "category") newSelectFilters.service = ""
          break
        case "clear":
          newSelectFilters[type.name] = ""
          break

        default:
          break
      }

      //update search filter tags from select filters
      const tags = getTagsFromUrl(newSelectFilters)
      let newSearchFilters = { ...searchFilters }
      if (tags && tags.length) {
        newSearchFilters.tags = tags
      } else if (newSearchFilters.tags) {
        delete newSearchFilters.tags
      }

      paramMoodboardLoad(newSearchFilters)
      updateSearchFilters(newSearchFilters)
      getImages(newSearchFilters)
      selectMoodboardLoad(newSelectFilters)
      updateURL(newSelectFilters)
      return newSelectFilters
    })
  }

  const clearAllFilters = () => {
    const newSelectFilters = {
      category: "",
      style: "",
      service: "",
      setting: "",
    }
    updateSelectFilters(newSelectFilters)
    selectMoodboardLoad(newSelectFilters)
    updateURL(newSelectFilters)
    let newSearchFilters = { ...searchFilters, tags: "" }
    delete newSearchFilters.tags
    paramMoodboardLoad(newSearchFilters)
    updateSearchFilters(newSearchFilters)
    getImages(newSearchFilters)
  }

  const handleImageSelection = (image, prevSelected) => {
    const id = image.id
    const selected = !prevSelected
    let data = {}
    if (selected) {
      const supplier = isNaN(image.author) ? JSON.parse(image.author) : image.author
      data = {
        id: image.id,
        url: image.url,
        supplier: supplier,
        custom: image.customData,
        tags: image.tags,
      }
    }

    let newImages
    if (selected) {
      newImages = { ...imagesSelectedMoodboard, [id]: data }
    } else {
      const { [id]: omit, ...newRemoved } = imagesSelectedMoodboard
      newImages = newRemoved
    }
    updateIsImageSelected(!!(newImages && Object.keys(newImages).length))

    imagesSelectedMoodboardLoad(newImages)
  }

  const clearAllSelectedImages = () => {
    imagesSelectedMoodboardLoad({})
    updateIsImageSelected(false)
  }

  const handleSubmit = () => {
    let supplierIds = []
    for (const [id, data] of Object.entries(imagesSelectedMoodboard)) {
      const supplier = typeof data.supplier === "object" && data.supplier !== null ? data.supplier.id : data.supplier
      if (supplier && supplierIds.indexOf(supplier) === -1) supplierIds.push(supplier)
    }
    if (supplierIds.length) {
      router.push(`/suppliers-search/?ids=${JSON.stringify(supplierIds)}`)
    }
  }

  return (
    <div className={`${styles.MoodboardSearch}`}>
      <MoodboardSelectBar
        clearAllSelectedImages={clearAllSelectedImages}
        clearAllFilters={clearAllFilters}
        isImageSelected={isImageSelected}
        handleSubmit={handleSubmit}
        handleSelectChange={handleSelectChange}
        selectFilters={selectFilters}
        count={Object.keys(imagesSelectedMoodboard).length}
      />

      <MoodboardSidebar
        isImageSelected={isImageSelected}
        imagesSelected={Object.values(imagesSelectedMoodboard)}
        count={Object.keys(imagesSelectedMoodboard).length}
        imigixParams={imigixParams}
        handleImageSelection={handleImageSelection}
        clearAllSelectedImages={clearAllSelectedImages}
        handleSubmit={handleSubmit}
      />
      <section className={styles.SearchArea}>
        <div className={styles.scrollingSection}>
          <main>
            <SiteWrapper className={styles.SearchAreaWrapper} full>
              <ImageList
                images={images}
                empty={empty}
                loadFunc={loadMore}
                hasMore={loadMoreActive}
                handleChange={handleImageSelection}
                imagesSelected={imagesSelectedMoodboard}
                clearAllFilters={clearAllFilters}
                imigixParams={imigixParams}
              />
            </SiteWrapper>
          </main>
        </div>
      </section>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    moodboardParams: state.search.paramMoodboard,
    selectMoodboard: state.search.selectMoodboard,
    imagesSelectedMoodboard: state.search.imagesSelectedMoodboard,
    staticData: state.staticData.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paramMoodboardLoad: (paramMoodboard) => dispatch(actions.paramMoodboardLoad(paramMoodboard)),
    selectMoodboardLoad: (selectMoodboard) => dispatch(actions.selectMoodboardLoad(selectMoodboard)),
    imagesSelectedMoodboardLoad: (imagesSelectedMoodboard) =>
      dispatch(actions.imagesSelectedMoodboardLoad(imagesSelectedMoodboard)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MoodboardSearch)
